export function getInstallationContractDatePresentation(input: {
  contractId?: unknown;
  contractDatesFixed?: unknown;
  contractualEndDate?: string | null;
  realStartDate?: unknown;
}) {
  const isCanonicalContract = input.contractId != null;
  const legacyContractBadge = !isCanonicalContract && input.contractDatesFixed === true;
  const contractualDeadline = isCanonicalContract ? input.contractualEndDate ?? null : null;

  return {
    legacyContractBadge,
    contractualDeadline,
    showDateBlock: Boolean(input.realStartDate || contractualDeadline || legacyContractBadge),
  };
}
